<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options"/>

    <vuetablemodifier_form
      ref="modifierSetsForm"
      @modifierset-saved="refresh"/>

    <vuetable-modifier-fnb-form
      ref="modifierSetsFnbForm"
      @modifiersetfnb-saved="refresh"/>

    <import-modifier
      ref="importModifier"
      @import-completed="refresh"/>
  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import VuetableCheckbox from '../../../components/vuetable2/checkbox/state';
import Feature from '@js/plugins/feature';
import vuetableModifierFnbForm from './vuetablemodifier_fnb_form';
import importModifier from './import-modifier.vue';
import { Event } from '../../../event-bus';
const TableName = 'VUETABLE_MODIFIER';

export default {
    components: {
        vuetableModifierFnbForm,
        importModifier,
    },

    data() {
        var that = this;
        let canManageItems = Auth.hasPermissionTo('franchise_manage_items');
        let viewOnlyItems = Auth.hasPermissionTo('admin_view_only_system');

        let actionButtons = [
            {
                title: 'Create Modifier',
                action: () => {
                    this.showForm(null);
                },
            },
            {
                title: 'Import Modifier',
                action: () => {
                    this.showImportModal();
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        if (viewOnlyItems) {
            actionButtons = [];
        }
        return {
            modifier: {},
            tableName: TableName,
            api: Laroute.route('franchise.inventory.modifier.index'),
            inventoryFnb: Feature.hasFeature('inventory_fnb'),
            columns: ['name', 'products'],
            options: {
                checkbox: canManageItems && !viewOnlyItems,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.modifier.delete',
                    ),
                    delete_title: 'Delete Modifiers',
                },
                customFilters: ['outlet_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                sortable: ['name'],
                headings: {
                    name: 'Name',
                    products: 'Products',
                    actions: 'Action',
                },
                templates: {
                    products(h, row) {
                        return require('./vuetablemodifier_items.jsx')(h, row);
                    },
                },
                csv_url: Laroute.route(
                    'franchise.inventory.modifier.exportAsFile',
                    { type: 'CSV' },
                ),
                pdf_url: Laroute.route(
                    'franchise.inventory.modifier.exportAsFile',
                    { type: 'PDF' },
                ),
                actionButtons: actionButtons,
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showForm,
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    created() {
        this.$store.registerModule(`CHECKBOX_${TableName}`, VuetableCheckbox);
    },

    mounted() {
        Event.$on('import-completed', () => {
            this.refresh();
        });
    },

    methods: {
        showForm(row) {
            if (!this.inventoryFnb) {
                this.$refs.modifierSetsForm.$emit('show-form', row);
            } else {
                this.$refs.modifierSetsFnbForm.$emit('show-form', row);
            }
        },

        showImportModal() {
            $('#import-modifier').modal('show');
        },

        refresh() {
            this.$refs.datatable.refresh();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/modifier/vuetable_modifier.vue